import { render, staticRenderFns } from "./ParticipationRules.vue?vue&type=template&id=7bae399f&"
import script from "./ParticipationRules.vue?vue&type=script&lang=js&"
export * from "./ParticipationRules.vue?vue&type=script&lang=js&"
import style0 from "./ParticipationRules.vue?vue&type=style&index=0&id=7bae399f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports